var exports = {
  "k": "xcc377c0b--899482--container",
};

module.exports = exports;
